import {formatAddress} from '@deliveriesondemand/dod-utils';
import {abbreviations} from '@deliveriesondemand/dod-states';
import {GeoSuggest} from '@deliveriesondemand/dod-components';
import {zipRe} from '@deliveriesondemand/dod-regexes';
import {Component, Fragment} from 'react';

import {Control} from '-/components/fields/Control';
import TextInput from '-/components/fields/TextInput';
import Select from '-/components/fields/Select';
import CreditorService from '-/services/CreditorService';

export default class Address extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            value: null,
            foundMatch: null
        };
    }

    getErrors(label = 'Address') {
        const {value = {}} = this.state;
        const {street1, city, state, zip} = value;
        const errors = [];

        if (!value || !street1) {
            errors.push(`${label}: Street 1 is empty`);
        }

        if (!city) {
            errors.push(`${label}: City is empty`);
        }

        if (!state) {
            errors.push(`${label}: State is empty`);
        }

        if (!zip) {
            errors.push(`${label}: Zip Code is empty`);
        } else if (!zipRe.test(zip)) {
            errors.push(`${label}: Zip Code is invalid`);
        }

        return errors;
    }

    componentDidMount() {
        const {value} = this.props;

        this.updateValue(value);
    }

    componentWillReceiveProps(nextProps) {
        this.updateValue(nextProps.value);
    }

    updateValue(value) {
        this.setState({value});
    }

    handleChange(value) {
        const {onChange} = this.props;
        value = {street1: value};

        this.setState({value});
        onChange(value);
    }

    onAddressPartChange(part, inputValue) {
        const {value = {}} = this.state;
        const {onChange} = this.props;
        const updatedAddress = {
            ...value,
            [part]: inputValue
        };

        updatedAddress.formatted = formatAddress(updatedAddress);

        this.setState({value: updatedAddress});
        onChange(updatedAddress);
    }

    handleBlur = () => {
        const {foundMatch} = this.state;

        if (foundMatch) {
            this.setState({foundMatch: null});
        }
    };

    handleUpdateSuggests = () => {
        this.setState({foundMatch: true});
    };

    handleNoResults = () => {
        this.setState({foundMatch: false});
    };

    handleSelect(selection) {
        if (selection) {
            const {city, county, state, street1, zip} = selection;
            const {onChange} = this.props;
            
            const value = {city, county, state, street1, zip};

            value.formatted = formatAddress(value);

            this.setState({value});

            onChange(value);
        }
    }

    render() {
        const {value = {}} = this.state;

        if (!value) {
            return null;
        }

        const {city, state, street1, street2, zip} = value;
        const {label = 'Street 1', labelWidth = 200, placeholder} = this.props;
        const coordinates = CreditorService.getGeolocationCoordinates();

        return (
            <Fragment>
                <Control labelWidth={labelWidth}>
                    <GeoSuggest
                        coordinates={coordinates}
                        label={label}
                        placeholder={placeholder}
                        incomingValue={street1}
                        onChange={this.onAddressPartChange.bind(this, 'street1')}
                        onSelect={this.handleSelect} />
                </Control>
                <Control labelWidth={labelWidth}>
                    <TextInput
                        label="Street 2"
                        placeholder="Apt. 501"
                        value={street2}
                        onChange={this.onAddressPartChange.bind(this, 'street2')} />
                </Control>
                <Control labelWidth={labelWidth}>
                    <TextInput
                        label="City"
                        placeholder="St. Louis"
                        value={city}
                        onChange={this.onAddressPartChange.bind(this, 'city')} />
                </Control>
                <Control labelWidth={labelWidth}>
                    <Select
                        label="State"
                        value={state}
                        onChange={this.onAddressPartChange.bind(this, 'state')}>
                        <option>Select a State</option>
                        {Object.keys(abbreviations).map((key, i) => {
                            return (
                                <option
                                    key={i}
                                    selected={key === state}
                                    value={key}>
                                    {abbreviations[key]}
                                </option>
                            );
                        })}
                    </Select>
                </Control>
                <Control labelWidth={labelWidth}>
                    <TextInput
                        allowedRegex={/[^0-9]/}
                        maxLength={5}
                        label="Zip Code"
                        placeholder="63105"
                        value={zip}
                        onChange={this.onAddressPartChange.bind(this, 'zip')} />
                </Control>
            </Fragment>
        );
    }
}
